import { handleActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = ''

export default handleActions(
  {
    [rawActions.updateSearchText](state, action) {
      return action.payload
    },
    [rawActions.clearSearchText](state, action) {
      return defaultState
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
